import { createEvent, restore, sample } from 'effector'
import { libraryGridFavoritesTvChannelsWidget } from '~/widgets/library/grid/favorites/tvChannels'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridFavoritesTvChannelsWidget.$isGridFavoritesTvChannelsLoading,
  target: setContentLoading,
})
